export function generateId() {
    if (crypto && typeof crypto.randomUUID == "function")
        return crypto.randomUUID();
    else 
        return (Math.random() + 1).toString(36).slice(-8);
}